import React from 'react';

export enum SpacerSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
}

interface SpacerProps {
  size?: SpacerSize;
  className?: string;
}

const sizeClasses = {
  xs: 'h-1 w-1',
  sm: 'h-2 w-2',
  md: 'h-4 w-4',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
  xxl: 'h-12 w-12',
};

export const Spacer: React.FC<SpacerProps> = ({size = SpacerSize.MD, className = ''}) => {
  const classes = [sizeClasses[size], className].filter(Boolean).join(' ');

  return <div className={classes} />;
};

export const FlexSpacer: React.FC<{className?: string}> = ({className = ''}) => {
  return <div className={`flex-1 ${className}`} />;
};
